import { Skeleton } from "@/design-system";
import { Footer, Header, WhatsAppFloatButton } from "@/pages/landingPage/components";
import type { ReactNode } from "react";

/**
 * Moldura da página de post.
 *
 * Mesmo motivo do `ClusterPageShell`: os três estados (carregando, 404 e
 * conteúdo) nascem com o mesmo cabeçalho, a mesma largura e o mesmo respiro,
 * então a tela não salta quando o post chega.
 */
export const PostPageShell = ({
  children,
  width = "wide",
}: {
  children: ReactNode;
  /** `wide` é a página do post (texto + coluna lateral). `narrow` é o 404. */
  width?: "wide" | "narrow";
}) => (
  <div className="bg-ds-paper min-h-screen">
    <Header />
    <main
      className={
        width === "wide"
          ? "mx-auto w-full max-w-6xl px-4 pt-28 pb-16 sm:px-6"
          : "mx-auto flex min-h-[60vh] w-full max-w-2xl flex-col items-center justify-center gap-4 px-4 pt-28 pb-16 text-center"
      }
    >
      {children}
    </main>
    <Footer />
    <WhatsAppFloatButton />
  </div>
);

/**
 * Esqueleto do post, com a silhueta do conteúdo real: trilha, título,
 * assinatura e os primeiros parágrafos. Esqueleto em vez de spinner porque o
 * layout fica parado quando o texto chega.
 */
export const PostPageSkeleton = () => (
  <PostPageShell>
    <div role="status" aria-busy="true" className="mx-auto w-full max-w-3xl">
      <span className="sr-only">Carregando o artigo</span>
      <Skeleton className="h-4 w-1/2" />
      <Skeleton className="mt-6 h-10 w-4/5" />
      <Skeleton className="mt-4 h-4 w-2/5" />
      <Skeleton className="rounded-ds-lg mt-8 h-40 w-full" />
      <div className="mt-8 flex flex-col gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>
    </div>
  </PostPageShell>
);
